import React from "react";
import classes from "./Services.module.css";

const Massage = () =>{
    return (
        <h1>Massage</h1>
    );
}

export default Massage;